<template>
    <div class="group-rounded-box">
        <span class="title">ICE LS Gasoil Future Month Selection</span>

        <div class="row">
            <div class="form-group col-md-4" 
                v-for="(ice, key) in iceSelections" :key="key">
                <label>{{ice.text}}</label>
                <div class="select-wrapper">
                    <select v-model="rules.find(r => r.action.targetAttribute === ice.id).action.value"
                        @change="selectIceReference(ice.id, rules.find(r => r.action.targetAttribute === ice.id).action.value)">
                        <option v-for="(option, index) in monthOptions" :key="index" 
                            :value="option.id" :disabled="option.id === -1">
                            {{ option.text }}
                        </option>
                    </select>
                </div>
            </div>

            <!-- <div class="form-group col-md-4">
                <label>Live add-on ({{ getRulesEnums.eUnitType.UsdPerMetricTonne.display }})</label>
                <cleave 
                    :options="numeral" 
                    placeholder="0.00" 
                    class="form-control text-center" 
                    v-model="rules.find(r => r.action.targetAttribute === getRulesEnums.eTargetAttributeType.IceLivePremium).action.value" 
                    @input="updateIceLivePremiumForCalculation($event)" 
                    @blur.native="setIceLivePremiumDecimalPoints($event.target.value)"
                ></cleave>
            </div> -->
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import { mapGetters } from "vuex";
import { getIceSymbol } from "@/util/calculations";
import { rulesEnum } from "@/util/enums/rules";

export default {
    mixins: [breakpoint],
    props: {
        rules: {
            type: Array,
            required: true
        },
        componentKey: {
            type: String,
            default: "MARKET"
        }
    },
    data(){
        return {
            monthOptions: [
                { text: "Select Month", id: -1 },
                { text: "M00", id: 0 },
                { text: "M01", id: 1 },
                { text: "M02", id: 2 }
            ]
        }
    },
    computed: {
        ...mapGetters('inputCheckers', ['numeral']),
        iceSelections: {
            get: function(){
                return [
                    { text: "Live", id: rulesEnum.eTargetAttributeType.IceLive },
                    { text: "Settlement", id: rulesEnum.eTargetAttributeType.IceSettle }
                ]
            }
        },
        trackInvalidRule: function(){ // Flag to the parent component whether there is error found or not
            let status = this.rules.map(r => r.action.value).includes(-1);
            this.$emit("errorFound", this.componentKey, status);
        }
    },
    watch: {
        trackInvalidRule(){}
    },
    methods: {
        selectIceReference: function(priceType, month){
            if (month < 0)
                return;
            
            const symbol = getIceSymbol(month);
            this.$emit("assignIceData", priceType, symbol);
        },
        setIceLivePremiumDecimalPoints: function(newValue){
            // Set the ICE add-on to 2 decimal places
            this.rules.find(r => r.action.targetAttribute === rulesEnum.eTargetAttributeType.IceLivePremium).action.value = Number(newValue).toFixed(2);
        },
        updateIceLivePremiumForCalculation: function(newValue){
            const iceLivePremium = Number(newValue);
            if (!Number.isNaN(iceLivePremium)) this.$emit("assignIceData", rulesEnum.eTargetAttributeType.IceLivePremium, iceLivePremium);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>